import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import ruleService from './ruleService'

const initialState = {
    rules: [],
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: ''
};

// Get device rules
export const updateRules = createAsyncThunk('rules/get', async (data, thunkAPI) => {
    return data;
})

export const ruleSlice = createSlice({
    name: 'rule',
    initialState,
    reducers: {
        reset: (state) => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(updateRules.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateRules.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.isError = false;
                state.rules = [ ...action.payload ];
            })
            .addCase(updateRules.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = action.payload;
            })
    }
})

export const { reset } = ruleSlice.actions;
export default ruleSlice.reducer;